package com.dotdrives.web.pages.donor

import com.dotdrives.model.DonorSubscription
import com.dotdrives.web.pages.dashboard.money as existingMoney
import kotlin.time.Instant

internal fun donorMoney(value: Double): String =
    if (value.isFinite()) existingMoney(value) else "—"

internal fun donorDate(value: Instant?): String = value?.toString()?.take(10) ?: "Date unavailable"

internal fun subscriptionStatus(plan: DonorSubscription): String =
    when {
        plan.cancelAtPeriodEnd -> "Cancellation scheduled at period end"
        plan.status == "paused" -> "Paused until you resume"
        plan.paymentStatus in setOf("past_due", "unpaid", "incomplete", "incomplete_expired") ->
            "Payment ${plan.paymentStatus?.replace('_', ' ')}"
        else -> plan.status.replace('_', ' ').replaceFirstChar { it.uppercase() }
    }

internal fun donorPaymentLabel(value: String): String =
    when (value) {
        "ach" -> "Bank transfer (ACH)"
        "wire" -> "Wire transfer"
        else -> value.replace('_', ' ').replaceFirstChar { it.uppercase() }
    }

internal fun donorSourceLabel(value: String): String =
    when (value) {
        "form" -> "Giving form"
        "manual" -> "Recorded by organization"
        "stripe" -> "Online payment"
        else -> value.replace('_', ' ').replaceFirstChar { it.uppercase() }
    }
